//! Change in '../../../../../app/utils/date/date-utils-yyyy-mm-dd' as well
/**
 * @param date
 * @returns string YYYY-MM-DD
 */
export function formatDateYyyyMmDd(date: Date): string {
  return date.toISOString().split('T')[0]
}
